// extracted by mini-css-extract-plugin
module.exports = {"tabs":"TabBar_tabs__3_FkU","tab":"TabBar_tab__3bvo9","activeTab":"TabBar_activeTab__1LVF-","hr":"TabBar_hr__8_I4x","thickLine":"TabBar_thickLine__JEQG5"};